import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { WorkspaceComponent } from './pages/workspace/workspace.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { workspaceAccessGuard } from './guards/workspace-access.guard';
import { RepositoriesComponent } from './pages/repositories/repositories.component';
import { JsonViewerComponent } from './components/json-viewer/json-viewer.component';
import { DocsComponent } from './pages/docs/docs.component';
import { Docs2Component } from './pages/docs2/docs2.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { UsdmComponent } from './pages/usdm/usdm.component';
import { Usdm2Component } from './pages/usdm2/usdm2.component';
import { LoginComponent } from './pages/login/login.component';
import { SignupComponent } from './pages/signup/signup.component';
import { sdtmAccessGuard } from './sdtm/sdtm-access.guard';
import { syntheticAccessGuard } from './synthetic/synthetic-access.guard';
import { sapAccessGuard } from './sap/sap-access.guard';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  {
    path: 'workspace',
    component: WorkspaceComponent,
    canActivate: [workspaceAccessGuard]
  },
  { path: 'settings', component: SettingsComponent },
  { path: 'repositories', component: RepositoriesComponent },
  { path: 'usdm-viewer', component: JsonViewerComponent },
  { path: 'docs-old', component: DocsComponent },
  { path: 'docs', component: Docs2Component },
  { path: 'profile', component: DashboardComponent },
  { path: 'usdm-old', component: UsdmComponent },
  { path: 'usdm', component: Usdm2Component },
  {
    path: 'sdtm',
    canActivate: [sdtmAccessGuard],
    loadChildren: () => import('./sdtm/sdtm.routes').then((m) => m.SDTM_ROUTES),
  },
  {
    path: 'tfl',
    loadChildren: () => import('./tfl/tfl.routes').then((m) => m.TFL_ROUTES),
  },
  {
    path: 'sap',
    canActivate: [sapAccessGuard],
    loadChildren: () => import('./sap/sap.routes').then((m) => m.SAP_ROUTES),
  },
  {
    path: 'synthetic',
    canActivate: [syntheticAccessGuard],
    loadChildren: () => import('./synthetic/synthetic.routes').then((m) => m.SYNTHETIC_ROUTES),
  },
  { path: '**', redirectTo: '' }
];
